import React, { useEffect, useState } from "react";
import { Col, Form, Input, Modal, Row } from "antd";
import { POST, PATCH } from "../../frameworks/HttpClient";
import { URL_TRUCK } from "../../constants/urls";
import { DATE_FORMAT } from "../../constants/string";
import ErrorMessages from "../../common/ErrorMessages";
import CustomDatePicker from "../../common/CustomDatePicker";
import dayjs from 'dayjs';

export default function DailyPurchasingPriceListModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages , setErrorMessages ] = useState(null);

  useEffect(() => {
    if (target) {
      setErrorMessages(null)
      form.setFieldsValue(target);
    } else {  
      form.resetFields();
      form.setFieldValue('date', dayjs().format(DATE_FORMAT))
    }
  }, [open]);

  const handleOK = async () => {
    setLoading(true);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        delete data['date'] 
        await PATCH(`${URL_TRUCK.RAW_LATEX_PRICE_LIST}${target.id}/`, data);
      } else {
        await POST(URL_TRUCK.RAW_LATEX_PRICE_LIST, data);
      }
      onUpdate();
      form.resetFields();
    } catch (error) {
        setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  const disabledDate = current => {
    // Can not select days before today and today
    return current && dayjs(current).isBefore(dayjs(), 'day')
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขราคารับซื้อ" : "กำหนดราคารับซื้อ"}
      width={600}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: {
          backgroundColor: target ? "#FFA500" : "#34C759",
          borderColor: target ? "#FFA500" : "#34C759",
          color: "#FFFFFF",
        },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} /> 
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <CustomDatePicker
              label="วันที่รับซื้อ"
              name="date"
              rules={[{ required: true, message: "กรุณาระบุวันที่" }]}
              disabled={target ? true : false}
              format={DATE_FORMAT}
              placeholder="วันที่รับซื้อ"
              // disabledDate={disabledDate}
            />
          </Col>
          <Col span={12}>
            <Form.Item
              label="ราคาน้ำยางแห้ง (บาท/กิโลกรัม)"
              name="price"
              rules={[{ required: true, message: "กรุณาระบุราคาน้ำยางแห้ง" }]}
            >
              <Input 
                placeholder="กรอกราคาน้ำยางแห้ง" 
                // disabled={target ? dayjs(target.date).isBefore(dayjs(), 'day') : false} 
                autoComplete='off'
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
